import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 310 305",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M182.337 148.294C183.101 148.465 183.253 149.713 182.538 150.038C168.738 154.736 157.875 166.746 152.203 182.735C151.893 183.51 150.531 183.323 150.403 182.495C148.463 169.956 139.799 159.944 128.638 157.242C127.898 157.063 127.759 155.901 128.447 155.572C142.617 149.742 153.267 137.782 158.187 122.503C158.495 121.705 159.98 121.907 160.106 122.754C162.014 135.543 170.91 145.739 182.337 148.294Z",
      fill: "var(--dt-color-foreground-muted)"
    }, null, -1)
  ]))]))
}
export default { render: render }